import { render, staticRenderFns } from "./SalidaNewManual.vue?vue&type=template&id=c4fe7312&scoped=true&"
import script from "./SalidaNewManual.vue?vue&type=script&lang=ts&"
export * from "./SalidaNewManual.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fe7312",
  null
  
)

export default component.exports